<template>
  <div
    ref="catBtn"
    class="button button--sm button--secondary button--ico"
    @click="changeToggleCategory()"
    :class="[
      isFixed ? 'category-fixed' : '',
    ]"
  >
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.47316 11.36C2.40976 11.2993 2.335 11.2517 2.25316 11.22C2.09086 11.1533 1.9088 11.1533 1.7465 11.22C1.66466 11.2517 1.5899 11.2993 1.5265 11.36C1.4658 11.4234 1.41823 11.4982 1.3865 11.58C1.33544 11.7014 1.32149 11.8352 1.34641 11.9645C1.37133 12.0939 1.43399 12.2129 1.5265 12.3067C1.5913 12.3656 1.66571 12.4129 1.7465 12.4467C1.8263 12.4819 1.91258 12.5002 1.99983 12.5002C2.08708 12.5002 2.17336 12.4819 2.25316 12.4467C2.33395 12.4129 2.40836 12.3656 2.47316 12.3067C2.56567 12.2129 2.62833 12.0939 2.65325 11.9645C2.67816 11.8352 2.66422 11.7014 2.61316 11.58C2.58143 11.4982 2.53386 11.4234 2.47316 11.36ZM4.6665 5.83333H13.9998C14.1766 5.83333 14.3462 5.7631 14.4712 5.63807C14.5963 5.51305 14.6665 5.34348 14.6665 5.16667C14.6665 4.98986 14.5963 4.82029 14.4712 4.69526C14.3462 4.57024 14.1766 4.5 13.9998 4.5H4.6665C4.48969 4.5 4.32012 4.57024 4.19509 4.69526C4.07007 4.82029 3.99983 4.98986 3.99983 5.16667C3.99983 5.34348 4.07007 5.51305 4.19509 5.63807C4.32012 5.7631 4.48969 5.83333 4.6665 5.83333ZM2.47316 8.02667C2.37941 7.93416 2.26036 7.8715 2.13104 7.84658C2.00171 7.82167 1.8679 7.83561 1.7465 7.88667C1.66571 7.92043 1.5913 7.96778 1.5265 8.02667C1.4658 8.09007 1.41823 8.16483 1.3865 8.24667C1.35123 8.32647 1.33301 8.41275 1.33301 8.5C1.33301 8.58725 1.35123 8.67353 1.3865 8.75333C1.42026 8.83412 1.46761 8.90853 1.5265 8.97333C1.5913 9.03222 1.66571 9.07957 1.7465 9.11333C1.8263 9.1486 1.91258 9.16682 1.99983 9.16682C2.08708 9.16682 2.17336 9.1486 2.25316 9.11333C2.33395 9.07957 2.40836 9.03222 2.47316 8.97333C2.53205 8.90853 2.5794 8.83412 2.61316 8.75333C2.64843 8.67353 2.66665 8.58725 2.66665 8.5C2.66665 8.41275 2.64843 8.32647 2.61316 8.24667C2.58143 8.16483 2.53386 8.09007 2.47316 8.02667ZM13.9998 7.83333H4.6665C4.48969 7.83333 4.32012 7.90357 4.19509 8.0286C4.07007 8.15362 3.99983 8.32319 3.99983 8.5C3.99983 8.67681 4.07007 8.84638 4.19509 8.9714C4.32012 9.09643 4.48969 9.16667 4.6665 9.16667H13.9998C14.1766 9.16667 14.3462 9.09643 14.4712 8.9714C14.5963 8.84638 14.6665 8.67681 14.6665 8.5C14.6665 8.32319 14.5963 8.15362 14.4712 8.0286C14.3462 7.90357 14.1766 7.83333 13.9998 7.83333ZM2.47316 4.69333C2.40976 4.63264 2.335 4.58506 2.25316 4.55333C2.13176 4.50228 1.99795 4.48833 1.86862 4.51325C1.73929 4.53816 1.62025 4.60083 1.5265 4.69333C1.46761 4.75813 1.42026 4.83254 1.3865 4.91333C1.35123 4.99313 1.33301 5.07942 1.33301 5.16667C1.33301 5.25391 1.35123 5.3402 1.3865 5.42C1.42026 5.50079 1.46761 5.5752 1.5265 5.64C1.5913 5.69889 1.66571 5.74624 1.7465 5.78C1.8679 5.83105 2.00171 5.845 2.13104 5.82009C2.26036 5.79517 2.37941 5.73251 2.47316 5.64C2.53205 5.5752 2.5794 5.50079 2.61316 5.42C2.64843 5.3402 2.66665 5.25391 2.66665 5.16667C2.66665 5.07942 2.64843 4.99313 2.61316 4.91333C2.5794 4.83254 2.53205 4.75813 2.47316 4.69333ZM13.9998 11.1667H4.6665C4.48969 11.1667 4.32012 11.2369 4.19509 11.3619C4.07007 11.487 3.99983 11.6565 3.99983 11.8333C3.99983 12.0101 4.07007 12.1797 4.19509 12.3047C4.32012 12.4298 4.48969 12.5 4.6665 12.5H13.9998C14.1766 12.5 14.3462 12.4298 14.4712 12.3047C14.5963 12.1797 14.6665 12.0101 14.6665 11.8333C14.6665 11.6565 14.5963 11.487 14.4712 11.3619C14.3462 11.2369 14.1766 11.1667 13.9998 11.1667Z"
        fill="#1E0028"
      />
    </svg>

    Categorias
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "CategoriesBtn",
  data() {
    return {
      isFixed: false,
    };
  },
  computed: {
    ...mapGetters({
      toggleCategory: "toggleCategory",
    }),
  },
  methods: {
    changeToggleCategory() {
      this.$store.commit("setToggleCategory", !this.toggleCategory);
    },
  },
  mounted() {
    let scroll;
    const btnPos = this.$refs.catBtn.offsetTop / 1.2;
    document.addEventListener("scroll", () => {
      scroll = window.pageYOffset;
      this.isFixed = scroll > btnPos;
    });
  }
};
</script>
